// Components/EditRoomType.jsx
import React, { useState, useEffect } from "react";
import api from "../../../../../api/axios";
import Swal from "sweetalert2";

const EditRoomType = ({ open, onClose, roomType, onUpdated }) => {
  const [form, setForm] = useState({
    name: "",
    description: "",
    base_price: "",
    extra_adult_charge: "",
    extra_child_charge: "",
    is_active: true,
  });

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (roomType && open) {
      setForm({
        name: roomType.name,
        description: roomType.description,
        base_price: roomType.base_price,
        extra_adult_charge: roomType.extra_adult_charge,
        extra_child_charge: roomType.extra_child_charge,
        is_active: roomType.is_active,
      });
    }
  }, [roomType, open]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Basic validation
    if (!form.name.trim()) {
      Swal.fire({
        icon: "warning",
        title: "Room type name is required",
      });
      return;
    }

    try {
      setLoading(true);

      await api.put(`/pms/room-types/${roomType.id}`, form);

      Swal.fire({
        icon: "success",
        title: "Room Type Updated Successfully!",
        timer: 1400,
        showConfirmButton: false,
      });

      if (onUpdated) onUpdated();
      onClose();
    } catch (error) {
      console.error("Update room type failed:", error);

      Swal.fire({
        icon: "error",
        title: "Failed to update Room Type",
        text: error.response?.data?.message || "Something went wrong!",
      });
    } finally {
      setLoading(false);
    }
  };

  if (!open) return null;

  return (
    <>
      <div className="modal-backdrop fade show"></div>

      <div className="modal d-block">
        <div className="modal-dialog">
          <div className="modal-content">

            <div className="modal-header">
              <h5>Edit Room Type</h5>
              <button className="btn-close" onClick={onClose}></button>
            </div>

            <form onSubmit={handleSubmit}>
              <div className="modal-body">

                <label className="form-label">Room Type Name</label>
                <input
                  className="form-control mb-2"
                  value={form.name}
                  onChange={(e) => setForm({ ...form, name: e.target.value })}
                  required
                />

                <label className="form-label">Description</label>
                <textarea
                  className="form-control mb-2"
                  value={form.description}
                  onChange={(e) =>
                    setForm({ ...form, description: e.target.value })
                  }
                />

                <label className="form-label">Base Price</label>
                <input
                  type="number"
                  className="form-control mb-2"
                  value={form.base_price}
                  onChange={(e) =>
                    setForm({ ...form, base_price: e.target.value })
                  }
                />

                <label className="form-label">Extra Adult Charge</label>
                <input
                  type="number"
                  className="form-control mb-2"
                  value={form.extra_adult_charge}
                  onChange={(e) =>
                    setForm({ ...form, extra_adult_charge: e.target.value })
                  }
                />

                <label className="form-label">Extra Child Charge</label>
                <input
                  type="number"
                  className="form-control mb-2"
                  value={form.extra_child_charge}
                  onChange={(e) =>
                    setForm({ ...form, extra_child_charge: e.target.value })
                  }
                />

                <div className="form-check mt-2">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    checked={form.is_active}
                    onChange={() =>
                      setForm({ ...form, is_active: !form.is_active })
                    }
                  />
                  <label className="form-check-label">Active</label>
                </div>

              </div>

              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={onClose}>
                  Close
                </button>

                <button className="btn btn-primary" disabled={loading}>
                  {loading ? (
                    <span className="spinner-border spinner-border-sm" />
                  ) : (
                    "Update"
                  )}
                </button>
              </div>

            </form>

          </div>
        </div>
      </div>
    </>
  );
};

export default EditRoomType;
